<template>
    <div class="app min-h-screen" :class="{'is-mobile': $device.isMobile, 'is-tablet': $device.isTablet, 'is-desktop': $device.isDesktop}">
        <slot/>

		<client-only>
			<global-snackbar/>
			<global-popup-alert/>
			<legal-info-modal/>
		</client-only>

        <div class="popup-portal"/>
        <div class="overlay-portal"/>
		<div class="dropdown-portal"/>
		<div class="highest-portal"/>
		<div class="tooltip-portal"/>
    </div>
</template>

<style>
@charset "UTF-8";
/*********************
  Inputs
**********************/
/*********************
  Typography
**********************/
/*********************
  Inputs
**********************/
/*********************
  Shadows
**********************/
/*********************
  Layout
**********************/
/*********************
  Card
**********************/
/*********************
  Opacity
**********************/
.app {
  font-family: nunito-sans, Arial, Helvetica, sans-serif;
  font-style: normal;
  color: #465050;
  /*********************
       Links
  **********************/
  /*********************
    Headings
  **********************/
  /*********************
    Text
  **********************/
  /*********************
    Lists
  **********************/
}
.app *, .app :after, .app :before {
  box-sizing: inherit;
}
.app a {
  text-decoration: none;
  color: #008200;
  cursor: pointer;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
}
.app a:hover {
  text-decoration: none;
}
.app a.link:hover {
  text-decoration: underline;
}
.app h1, .app h2, .app h3, .app h4, .app h5, .app h6,
.app .h1, .app .h2, .app .h3, .app .h4, .app .h5, .app .h6 {
  color: #2e3535;
  font-family: "proxima-nova", "Trebuchet MS", Helvetica, sans-serif;
  margin-top: 0;
  margin-bottom: 16px;
}
.app h1 a, .app h2 a, .app h3 a, .app h4 a, .app h5 a, .app h6 a,
.app .h1 a, .app .h2 a, .app .h3 a, .app .h4 a, .app .h5 a, .app .h6 a {
  color: #2e3535;
}
.app h1, .app .h1 {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.app h2, .app .h2 {
  font-size: 22px;
  font-weight: 700;
}
.app h3, .app .h3 {
  font-size: 20px;
  font-weight: 700;
}
.app h4, .app .h4 {
  font-size: 16px;
}
.app p {
  line-height: 1.5;
  margin-bottom: 16px;
}
.app p.text-sm {
  line-height: 1.4;
}
.app blockquote {
  font-style: italic;
  line-height: 1.4;
}
.app blockquote:before {
  content: "„";
}
.app blockquote:after {
  content: "”";
}
.app ul {
  list-style: disc inside;
}
.app ol {
  list-style: decimal inside;
}
.app ul, .app ol {
  padding-left: 16px;
}
.app ul li, .app ol li {
  padding: 4px 0;
  list-style-position: outside;
}
</style>